export default __webpack_public_path__ + "static/media/instagramWhite.5cd45580.svg";